<script setup lang="ts">
import { useHomeSections } from '~/composables/apostatudo/use-home-sections';

// ============================================================================
// HOMEVIA - Renderização Dinâmica da Home
// ============================================================================
// Esta página suporta DUAS estruturas de API:
// 1. Nova API (HomeSectionData com items e content_type) -> Usa HomeSectionRenderer
// 2. Antiga API (HomeSection com categories) -> Usa renderização manual (compatibilidade)
//
// Os componentes below-the-fold usam o prefixo 'Lazy' no template
// Nuxt automaticamente cria dynamic imports para eles
// Componentes above-the-fold (sem Lazy) são staticamente importados
// ============================================================================

const {
  fetchHomeSections,
  validItems,
  loading: homeSectionsLoading,
  isUsingNewApi,
} = useHomeSections();

const { userCanOnlyWithdraw } = useUserLimits();
const { isWithinMigrationPeriod } = useFeatureFlagsNew();
const { isDesktop } = useLayout();

const { resetTracking } = useAboveFoldTracking();
const { initializePriorityLoading } = usePriorityLoading();

onMounted(() => {
  // Reset tracking quando a Home monta
  resetTracking();

  // Inicializa sistema de carregamento progressivo
  initializePriorityLoading();

  // Carrega as seções da home da API
  fetchHomeSections();
});
</script>

<template>
  <UserAccountProtectionAlertOnlyWithdraw />

  <WidgetsMigrationHomeMessage v-if="isWithinMigrationPeriod" />

  <div
    v-else-if="!userCanOnlyWithdraw"
    :class="$style.homePage"
  >
    <SectionsMenuHorizontalApostatudo v-if="isDesktop" />

    <SectionsSliderApostatudo v-if="isDesktop" />

    <BaseSearchContainer />

    <!-- ================================================================ -->
    <!-- NOVA API: HomeSectionRenderer (renderização dinâmica)            -->
    <!-- Nota: Componentes renderizados via PLACEHOLDER slugs pela API:   -->
    <!-- - jogos-favoritos -> CasinoFavoriteGamesList                     -->
    <!-- - vistos-recentemente -> CasinoLastGamesPlayed                   -->
    <!-- - banners (mobile) -> SectionsInformationBanners                 -->
    <!-- - provedoras-de-jogos -> SectionsProvidersSection                -->
    <!-- Desktop: SectionsSliderApostatudo fixo acima                     -->
    <!-- Mobile: SectionsInformationBanners via API (ordem dinâmica)      -->
    <!-- ================================================================ -->
    <template v-if="isUsingNewApi">
      <SectionsHomeSectionRenderer
        :above-fold-count="3"
        :items="validItems"
        :loading="homeSectionsLoading"
      />
    </template>
  </div>
</template>

<style module lang="postcss">
.homePage {
  @apply pb-2 sm:pb-4 -mt-4 lg:mt-4 xl:mt-[1.4rem];
}
</style>
